export const ApiResponseMessages = {
    SECTION_SENT_REWORK: "Sections sent for rework.",
    REPORT_GENERATION_INITIATED: "Report generation has been initiated.You will be notified via email once the report generation is completed.",
    SECTION_UPDATED: "Section updated successfully.",
    FAILED_TO_UPDATE_SECTION: "Failed to update section.",
    SECTION_ADDED:'Section added successfully.',
    FAILED_TO_ADD_SECTION:'Failed to add section.',
    SECTION_DELETED :'Section deleted successfully.',
    FAILED_TO_DELETE_SECTION:'Failed to delete section.',
    NO_REPORT_FOUND:'No reports found.',
    FAILED_TO_DELETE_REPORT:'Failed to delete report.',
    SENT_FOR_APPROVAL:'Report sent for approval.',
    COMMENT_DELETED:'Comment deleted successfully.',
    UPDATE_FROM_DATA: {
      CLIENT_CONFIG_NOT_LOADED: 'Client configuration not loaded. Please try again.',
      UPLOAD_FAILED: 'Failed to upload one or more files.',
      STARTING_ANALYSIS: 'Starting analysis...',
      FAILED_TO_START_ANALYSIS: 'Failed to start analysis.',
      SUBMISSION_FAILED: 'An error occurred while submitting the report.',
      UPLOAD_PROGRESS: '{uploaded} of {total} files uploaded...'
    }
  };